var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_1614_3388)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C16.3682 6 16.6667 6.29848 16.6667 6.66667V8.66667C16.6667 9.03486 16.3682 9.33333 16 9.33333C15.6318 9.33333 15.3333 9.03486 15.3333 8.66667V6.66667C15.3333 6.29848 15.6318 6 16 6ZM21.3333 16C21.3333 18.9455 18.9455 21.3333 16 21.3333C13.0545 21.3333 10.6667 18.9455 10.6667 16C10.6667 13.0545 13.0545 10.6667 16 10.6667C18.9455 10.6667 21.3333 13.0545 21.3333 16ZM16.6667 23.3333C16.6667 22.9651 16.3682 22.6667 16 22.6667C15.6318 22.6667 15.3333 22.9651 15.3333 23.3333V25.3333C15.3333 25.7015 15.6318 26 16 26C16.3682 26 16.6667 25.7015 16.6667 25.3333V23.3333ZM23.0716 23.0704C22.8112 23.3307 22.3891 23.3307 22.1288 23.0704L20.7145 21.6561C20.4542 21.3958 20.4542 20.9737 20.7145 20.7133C20.9749 20.453 21.397 20.453 21.6574 20.7133L23.0716 22.1276C23.3319 22.3879 23.3319 22.81 23.0716 23.0704ZM10.3436 11.2865C10.6039 11.5469 11.0261 11.5469 11.2864 11.2865C11.5468 11.0262 11.5468 10.604 11.2864 10.3437L9.87219 8.92949C9.61185 8.66914 9.18974 8.66914 8.92939 8.92949C8.66904 9.18984 8.66904 9.61195 8.92939 9.8723L10.3436 11.2865ZM26 16C26 16.3682 25.7015 16.6667 25.3333 16.6667H23.3333C22.9651 16.6667 22.6667 16.3682 22.6667 16C22.6667 15.6318 22.9651 15.3333 23.3333 15.3333H25.3333C25.7015 15.3333 26 15.6318 26 16ZM8.66667 16.6667C9.03486 16.6667 9.33333 16.3682 9.33333 16C9.33333 15.6318 9.03486 15.3333 8.66667 15.3333H6.66667C6.29848 15.3333 6 15.6318 6 16C6 16.3682 6.29848 16.6667 6.66667 16.6667H8.66667ZM23.0717 8.92974C23.332 9.19009 23.332 9.6122 23.0717 9.87255L21.6575 11.2868C21.3971 11.5471 20.975 11.5471 20.7146 11.2868C20.4543 11.0264 20.4543 10.6043 20.7146 10.344L22.1289 8.92974C22.3892 8.66939 22.8113 8.66939 23.0717 8.92974ZM11.2865 21.6564C11.5469 21.3961 11.5469 20.9739 11.2865 20.7136C11.0262 20.4532 10.604 20.4532 10.3437 20.7136L8.92949 22.1278C8.66914 22.3882 8.66914 22.8103 8.92949 23.0706C9.18984 23.331 9.61195 23.331 9.8723 23.0706L11.2865 21.6564Z",
    fill: "url(#paint1_linear_1614_3388)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1614_3388",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE79E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1614_3388",
    x1: 16,
    y1: 6,
    x2: 16,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.ee3230f0ca040d4099fd21c451efdebe.svg";
export { ForwardRef as ReactComponent };